export const isMaxSpaceLimitReached = (error: any) =>
  error.body?.error_details?.max_space_limit;
